module.exports = __webpack_public_path__ + "static/emerge-ed-bd74a5f5ab9528b599f3f4088a591a76.png";